import { IrisQueryParams, IrisQueryParamsFilter } from '@iris/api-query';
import { DfPropBaseSettings } from '@iris/common/modules/dynamic-forms/df-prop/shared/models/df-prop.base.settings';

export const NEVER_FILTER = new IrisQueryParamsFilter();
export const isNeverFilter = (filter: IrisQueryParamsFilter): boolean => filter === NEVER_FILTER || (!filter?.field && !filter?.or?.length);
export const isNeverFilterQueryParams = (params: IrisQueryParams): boolean => params?.filter?.some(t => isNeverFilter(t));

export function overrideFilterPropertySettings(propertySettings: DfPropBaseSettings): DfPropBaseSettings {
  return {
    ...propertySettings ?? {},
    isDisabled: false,
  };
}
